module.exports = __webpack_public_path__ + "static/media/Apple Watch 40mm Space Black Stainless Steel + Alaskan Blue Closed.0822213d.png";